module.exports = __webpack_public_path__ + "img/user-attribute-gray.01932fbc.svg";